import { INTERNAL_ROUTES } from '../static/Urls';
import { FetchUserCompanyDetails, UpdateUserCompanyDetails } from '@shared/api/dto/UserCompanyDetails';
import apiService from '../service/ApiService';
import { Operation } from '../static/Messages';
import { legacyGetOnError, legacyPostPutOnError, ValidationFailure } from './ApiUtils';
import { HTTP_RESPONSE_STATUS } from '@shared/static/Constants';
import { reportActionEvent } from '../tracking/tracking';

const userCompanyDetailsApiUrl = INTERNAL_ROUTES.API_PATH + '/api/usercompanydetails';

const doOnSuccess = (response: string | Record<string, ValidationFailure>) => {
  if (response === 'Customer Created') {
    reportActionEvent({
      pageTitle: 'customerdata',
      name: 'customerdata_created',
    });
  }
};

const fetchUserCompanyDetails = (): Promise<FetchUserCompanyDetails> => {
  return apiService.callGet<FetchUserCompanyDetails>(
    userCompanyDetailsApiUrl,
    { withCredentials: true },
    undefined,
    legacyGetOnError({ [HTTP_RESPONSE_STATUS.NOT_FOUND]: HTTP_RESPONSE_STATUS.NO_CONTENT }),
  );
};

const updateUserCompanyDetails = (
  payload: UpdateUserCompanyDetails,
): Promise<string | Record<string, ValidationFailure>> => {
  return apiService.callPut<UpdateUserCompanyDetails, string | Record<string, ValidationFailure>>(
    userCompanyDetailsApiUrl,
    payload,
    { withCredentials: true },
    { message: Operation.userCompanyUpdateSuccess },
    legacyPostPutOnError(),
  );
};

const createUserCompanyDetails = (
  payload: UpdateUserCompanyDetails,
): Promise<string | Record<string, ValidationFailure>> => {
  return apiService.callPost<UpdateUserCompanyDetails, string | Record<string, ValidationFailure>>(
    userCompanyDetailsApiUrl,
    payload,
    { withCredentials: true },
    {
      message: Operation.userCompanyCreateSuccess,
      doOnSuccess,
    },
    legacyPostPutOnError(),
  );
};

const userCompanyApi = {
  fetch: fetchUserCompanyDetails,
  update: updateUserCompanyDetails,
  create: createUserCompanyDetails,
};

export default userCompanyApi;
